import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'
import { managerStockMeta } from '../routes/metaData'
const DefaultManagerStockScreen = observer((props: any) => {
   const history = useHistory()
   useEffect(() => {
      history.push(managerStockMeta[0].path)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   return null
})

export default DefaultManagerStockScreen
